const countries = [
  { name: 'Afghanistan', value: '+93', label: 'AF(+93)' },
  { name: 'Åland Islands', value: '+358', label: 'AX(+358)' },
  { name: 'Albania', value: '+355', label: 'AL(+355)' },
  { name: 'Algeria', value: '+213', label: 'DZ(+213)' },
  { name: 'American Samoa', value: '+1-684', label: 'AS(+1-684)' },
  { name: 'AndorrA', value: '+376', label: 'AD(+376)' },
  { name: 'Angola', value: '+244', label: 'AO(+244)' },
  { name: 'Anguilla', value: '+1-264', label: 'AI(+1-264)' },
  { name: 'Antarctica', value: '+672', label: 'AQ(+672)' },
  { name: 'Antigua and Barbuda', value: '+1-268', label: 'AG(+1-268)' },
  { name: 'Argentina', value: '+54', label: 'AR(+54)' },
  { name: 'Armenia', value: '+374', label: 'AM(+374)' },
  { name: 'Aruba', value: '+297', label: 'AW(+297)' },
  { name: 'Australia', value: '+61', label: 'AU(+61)' },
  { name: 'Austria', value: '+43', label: 'AT(+43)' },
  { name: 'Azerbaijan', value: '+994', label: 'AZ(+994)' },
  { name: 'Bahamas', value: '+1-242', label: 'BS(+1-242)' },
  { name: 'Bahrain', value: '+973', label: 'BH(+973)' },
  { name: 'Bangladesh', value: '+880', label: 'BD(+880)' },
  { name: 'Barbados', value: '+1-246', label: 'BB(+1-246)' },
  { name: 'Belarus', value: '+375', label: 'BY(+375)' },
  { name: 'Belgium', value: '+32', label: 'BE(+32)' },
  { name: 'Belize', value: '+501', label: 'BZ(+501)' },
  { name: 'Benin', value: '+229', label: 'BJ(+229)' },
  { name: 'Bermuda', value: '+1-441', label: 'BM(+1-441)' },
  { name: 'Bhutan', value: '+975', label: 'BT(+975)' },
  { name: 'Bolivia', value: '+591', label: 'BO(+591)' },
  { name: 'Bosnia and Herzegovina', value: '+387', label: 'BA(+387)' },
  { name: 'Botswana', value: '+267', label: 'BW(+267)' },
  { name: 'Bouvet Island', value: '+47', label: 'BV(+47)' },
  { name: 'Brazil', value: '+55', label: 'BR(+55)' },
  { name: 'British Indian Ocean Territory', value: '+246', label: 'IO(+246)' },
  { name: 'Brunei Darussalam', value: '+673', label: 'BN(+673)' },
  { name: 'Bulgaria', value: '+359', label: 'BG(+359)' },
  { name: 'Burkina Faso', value: '+226', label: 'BF(+226)' },
  { name: 'Burundi', value: '+257', label: 'BI(+257)' },
  { name: 'Cambodia', value: '+855', label: 'KH(+855)' },
  { name: 'Cameroon', value: '+237', label: 'CM(+237)' },
  { name: 'Canada', value: '+1', label: 'CA(+1)' },
  { name: 'Cape Verde', value: '+238', label: 'CV(+238)' },
  { name: 'Cayman Islands', value: '+1-345', label: 'KY(+1-345)' },
  { name: 'Central African Republic', value: '+236', label: 'CF(+236)' },
  { name: 'Chad', value: '+235', label: 'TD(+235)' },
  { name: 'Chile', value: '+56', label: 'CL(+56)' },
  { name: 'China', value: '+86', label: 'CN(+86)' },
  { name: 'Christmas Island', value: '+61', label: 'CX(+61)' },
  { name: 'Cocos (Keeling) Islands', value: '+61', label: 'CC(+61)' },
  { name: 'Colombia', value: '+57', label: 'CO(+57)' },
  { name: 'Comoros', value: '+269', label: 'KM(+269)' },
  { name: 'Congo', value: '+242', label: 'CG(+242)' },
  {
    name: 'Congo, The Democratic Republic of the',
    value: '+243',
    label: 'CD(+243)',
  },
  { name: 'Cook Islands', value: '+682', label: 'CK(+682)' },
  { name: 'Costa Rica', value: '+506', label: 'CR(+506)' },
  { name: "Cote D'Ivoire", value: '+225', label: 'CI(+225)' },
  { name: 'Croatia', value: '+385', label: 'HR(+385)' },
  { name: 'Cuba', value: '+53', label: 'CU(+53)' },
  { name: 'Cyprus', value: '+357', label: 'CY(+357)' },
  { name: 'Czech Republic', value: '+420', label: 'CZ(+420)' },
  { name: 'Denmark', value: '+45', label: 'DK(+45)' },
  { name: 'Djibouti', value: '+253', label: 'DJ(+253)' },
  { name: 'Dominica', value: '+1-767', label: 'DM(+1-767)' },
  {
    name: 'Dominican Republic',
    value: '+1-809, +1-829, +1-849',
    label: 'DO(+1-809, +1-829, +1-849)',
  },
  { name: 'Ecuador', value: '+593', label: 'EC(+593)' },
  { name: 'Egypt', value: '+20', label: 'EG(+20)' },
  { name: 'El Salvador', value: '+503', label: 'SV(+503)' },
  { name: 'Equatorial Guinea', value: '+240', label: 'GQ(+240)' },
  { name: 'Eritrea', value: '+291', label: 'ER(+291)' },
  { name: 'Estonia', value: '+372', label: 'EE(+372)' },
  { name: 'Ethiopia', value: '+251', label: 'ET(+251)' },
  { name: 'Falkland Islands (Malvinas)', value: '+500', label: 'FK(+500)' },
  { name: 'Faroe Islands', value: '+298', label: 'FO(+298)' },
  { name: 'Fiji', value: '+679', label: 'FJ(+679)' },
  { name: 'Finland', value: '+358', label: 'FI(+358)' },
  { name: 'France', value: '+33', label: 'FR(+33)' },
  { name: 'French Guiana', value: '+594', label: 'GF(+594)' },
  { name: 'French Polynesia', value: '+689', label: 'PF(+689)' },
  { name: 'French Southern Territories', value: '+262', label: 'TF(+262)' },
  { name: 'Gabon', value: '+241', label: 'GA(+241)' },
  { name: 'Gambia', value: '+220', label: 'GM(+220)' },
  { name: 'Georgia', value: '+995', label: 'GE(+995)' },
  { name: 'Germany', value: '+49', label: 'DE(+49)' },
  { name: 'Ghana', value: '+233', label: 'GH(+233)' },
  { name: 'Gibraltar', value: '+350', label: 'GI(+350)' },
  { name: 'Greece', value: '+30', label: 'GR(+30)' },
  { name: 'Greenland', value: '+299', label: 'GL(+299)' },
  { name: 'Grenada', value: '+1-473', label: 'GD(+1-473)' },
  { name: 'Guadeloupe', value: '+590', label: 'GP(+590)' },
  { name: 'Guam', value: '+1-671', label: 'GU(+1-671)' },
  { name: 'Guatemala', value: '+502', label: 'GT(+502)' },
  { name: 'Guernsey', value: '+44-1481', label: 'GG(+44-1481)' },
  { name: 'Guinea', value: '+224', label: 'GN(+224)' },
  { name: 'Guinea-Bissau', value: '+245', label: 'GW(+245)' },
  { name: 'Guyana', value: '+592', label: 'GY(+592)' },
  { name: 'Haiti', value: '+509', label: 'HT(+509)' },
  {
    name: 'Heard Island and Mcdonald Islands',
    value: '+672',
    label: 'HM(+672)',
  },
  { name: 'Holy See (Vatican City State)', value: '+379', label: 'VA(+379)' },
  { name: 'Honduras', value: '+504', label: 'HN(+504)' },
  { name: 'Hong Kong', value: '+852', label: 'HK(+852)' },
  { name: 'Hungary', value: '+36', label: 'HU(+36)' },
  { name: 'Iceland', value: '+354', label: 'IS(+354)' },
  { name: 'India', value: '+91', label: 'IN(+91)' },
  { name: 'Indonesia', value: '+62', label: 'ID(+62)' },
  { name: 'Iran, Islamic Republic Of', value: '+98', label: 'IR(+98)' },
  { name: 'Iraq', value: '+964', label: 'IQ(+964)' },
  { name: 'Ireland', value: '+353', label: 'IE(+353)' },
  { name: 'Isle of Man', value: '+44-1624', label: 'IM(+44-1624)' },
  { name: 'Israel', value: '+972', label: 'IL(+972)' },
  { name: 'Italy', value: '+39', label: 'IT(+39)' },
  { name: 'Jamaica', value: '+1-876', label: 'JM(+1-876)' },
  { name: 'Japan', value: '+81', label: 'JP(+81)' },
  { name: 'Jersey', value: '+44-1534', label: 'JE(+44-1534)' },
  { name: 'Jordan', value: '+962', label: 'JO(+962)' },
  { name: 'Kazakhstan', value: '+7', label: 'KZ(+7)' },
  { name: 'Kenya', value: '+254', label: 'KE(+254)' },
  { name: 'Kiribati', value: '+686', label: 'KI(+686)' },
  {
    name: "Korea, Democratic People'S Republic of",
    value: '+850',
    label: 'KP(+850)',
  },
  { name: 'Korea, Republic of', value: '+82', label: 'KR(+82)' },
  { name: 'Kuwait', value: '+965', label: 'KW(+965)' },
  { name: 'Kyrgyzstan', value: '+996', label: 'KG(+996)' },
  {
    name: "Lao People'S Democratic Republic",
    value: '+856',
    label: 'LA(+856)',
  },
  { name: 'Latvia', value: '+371', label: 'LV(+371)' },
  { name: 'Lebanon', value: '+961', label: 'LB(+961)' },
  { name: 'Lesotho', value: '+266', label: 'LS(+266)' },
  { name: 'Liberia', value: '+231', label: 'LR(+231)' },
  { name: 'Libyan Arab Jamahiriya', value: '+218', label: 'LY(+218)' },
  { name: 'Liechtenstein', value: '+423', label: 'LI(+423)' },
  { name: 'Lithuania', value: '+370', label: 'LT(+370)' },
  { name: 'Luxembourg', value: '+352', label: 'LU(+352)' },
  { name: 'Macao', value: '+853', label: 'MO(+853)' },
  {
    name: 'Macedonia, The Former Yugoslav Republic of',
    value: '+389',
    label: 'MK(+389)',
  },
  { name: 'Madagascar', value: '+261', label: 'MG(+261)' },
  { name: 'Malawi', value: '+265', label: 'MW(+265)' },
  { name: 'Malaysia', value: '+60', label: 'MY(+60)' },
  { name: 'Maldives', value: '+960', label: 'MV(+960)' },
  { name: 'Mali', value: '+223', label: 'ML(+223)' },
  { name: 'Malta', value: '+356', label: 'MT(+356)' },
  { name: 'Marshall Islands', value: '+692', label: 'MH(+692)' },
  { name: 'Martinique', value: '+596', label: 'MQ(+596)' },
  { name: 'Mauritania', value: '+222', label: 'MR(+222)' },
  { name: 'Mauritius', value: '+230', label: 'MU(+230)' },
  { name: 'Mayotte', value: '+262', label: 'YT(+262)' },
  { name: 'Mexico', value: '+52', label: 'MX(+52)' },
  { name: 'Micronesia, Federated States of', value: '+691', label: 'FM(+691)' },
  { name: 'Moldova, Republic of', value: '+373', label: 'MD(+373)' },
  { name: 'Monaco', value: '+377', label: 'MC(+377)' },
  { name: 'Mongolia', value: '+976', label: 'MN(+976)' },
  { name: 'Montenegro', value: '+382', label: 'ME(+382)' },
  { name: 'Montserrat', value: '+1-664', label: 'MS(+1-664)' },
  { name: 'Morocco', value: '+212', label: 'MA(+212)' },
  { name: 'Mozambique', value: '+258', label: 'MZ(+258)' },
  { name: 'Myanmar', value: '+95', label: 'MM(+95)' },
  { name: 'Namibia', value: '+264', label: 'NA(+264)' },
  { name: 'Nauru', value: '+674', label: 'NR(+674)' },
  { name: 'Nepal', value: '+977', label: 'NP(+977)' },
  { name: 'Netherlands', value: '+31', label: 'NL(+31)' },
  { name: 'New Caledonia', value: '+687', label: 'NC(+687)' },
  { name: 'New Zealand', value: '+64', label: 'NZ(+64)' },
  { name: 'Nicaragua', value: '+505', label: 'NI(+505)' },
  { name: 'Niger', value: '+227', label: 'NE(+227)' },
  { name: 'Nigeria', value: '+234', label: 'NG(+234)' },
  { name: 'Niue', value: '+683', label: 'NU(+683)' },
  { name: 'Norfolk Island', value: '+672', label: 'NF(+672)' },
  { name: 'Northern Mariana Islands', value: '+1-670', label: 'MP(+1-670)' },
  { name: 'Norway', value: '+47', label: 'NO(+47)' },
  { name: 'Oman', value: '+968', label: 'OM(+968)' },
  { name: 'Pakistan', value: '+92', label: 'PK(+92)' },
  { name: 'Palau', value: '+680', label: 'PW(+680)' },
  { name: 'Palestinian Territory, Occupied', value: '+970', label: 'PS(+970)' },
  { name: 'Panama', value: '+507', label: 'PA(+507)' },
  { name: 'Papua New Guinea', value: '+675', label: 'PG(+675)' },
  { name: 'Paraguay', value: '+595', label: 'PY(+595)' },
  { name: 'Peru', value: '+51', label: 'PE(+51)' },
  { name: 'Philippines', value: '+63', label: 'PH(+63)' },
  { name: 'Pitcairn', value: '+64', label: 'PN(+64)' },
  { name: 'Poland', value: '+48', label: 'PL(+48)' },
  { name: 'Portugal', value: '+351', label: 'PT(+351)' },
  { name: 'Puerto Rico', value: '+1-787, +1-939', label: 'PR(+1-787, +1-939)' },
  { name: 'Qatar', value: '+974', label: 'QA(+974)' },
  { name: 'Réunion', value: '+262', label: 'RE(+262)' },
  { name: 'Romania', value: '+40', label: 'RO(+40)' },
  { name: 'Russian Federation', value: '+7', label: 'RU(+7)' },
  { name: 'Rwanda', value: '+250', label: 'RW(+250)' },
  { name: 'Saint Barthélemy', value: '+590', label: 'BL(+590)' },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    value: '+290',
    label: 'SH(+290)',
  },
  { name: 'Saint Kitts and Nevis', value: '+1-869', label: 'KN(+1-869)' },
  { name: 'Saint Lucia', value: '+1-758', label: 'LC(+1-758)' },
  { name: 'Saint Martin', value: '+590', label: 'MF(+590)' },
  { name: 'Saint Pierre and Miquelon', value: '+508', label: 'PM(+508)' },
  {
    name: 'Saint Vincent and the Grenadines',
    value: '+1-784',
    label: 'VC(+1-784)',
  },
  { name: 'Samoa', value: '+685', label: 'WS(+685)' },
  { name: 'San Marino', value: '+378', label: 'SM(+378)' },
  { name: 'Sao Tome and Principe', value: '+239', label: 'ST(+239)' },
  { name: 'Saudi Arabia', value: '+966', label: 'SA(+966)' },
  { name: 'Senegal', value: '+221', label: 'SN(+221)' },
  { name: 'Serbia', value: '+381', label: 'RS(+381)' },
  { name: 'Seychelles', value: '+248', label: 'SC(+248)' },
  { name: 'Sierra Leone', value: '+232', label: 'SL(+232)' },
  { name: 'Singapore', value: '+65', label: 'SG(+65)' },
  { name: 'Slovakia', value: '+421', label: 'SK(+421)' },
  { name: 'Slovenia', value: '+386', label: 'SI(+386)' },
  { name: 'Solomon Islands', value: '+677', label: 'SB(+677)' },
  { name: 'Somalia', value: '+252', label: 'SO(+252)' },
  { name: 'South Africa', value: '+27', label: 'ZA(+27)' },
  {
    name: 'South Georgia and the South Sandwich Islands',
    value: '+500',
    label: 'GS(+500)',
  },
  { name: 'Spain', value: '+34', label: 'ES(+34)' },
  { name: 'Sri Lanka', value: '+94', label: 'LK(+94)' },
  { name: 'Sudan', value: '+249', label: 'SD(+249)' },
  { name: 'Suriname', value: '+597', label: 'SR(+597)' },
  { name: 'Svalbard and Jan Mayen', value: '+47', label: 'SJ(+47)' },
  { name: 'Swaziland', value: '+268', label: 'SZ(+268)' },
  { name: 'Sweden', value: '+46', label: 'SE(+46)' },
  { name: 'Switzerland', value: '+41', label: 'CH(+41)' },
  { name: 'Syrian Arab Republic', value: '+963', label: 'SY(+963)' },
  { name: 'Taiwan, Province of China', value: '+886', label: 'TW(+886)' },
  { name: 'Tajikistan', value: '+992', label: 'TJ(+992)' },
  { name: 'Tanzania, United Republic of', value: '+255', label: 'TZ(+255)' },
  { name: 'Thailand', value: '+66', label: 'TH(+66)' },
  { name: 'Timor-Leste', value: '+670', label: 'TL(+670)' },
  { name: 'Togo', value: '+228', label: 'TG(+228)' },
  { name: 'Tokelau', value: '+690', label: 'TK(+690)' },
  { name: 'Tonga', value: '+676', label: 'TO(+676)' },
  { name: 'Trinidad and Tobago', value: '+1-868', label: 'TT(+1-868)' },
  { name: 'Tunisia', value: '+216', label: 'TN(+216)' },
  { name: 'Turkey', value: '+90', label: 'TR(+90)' },
  { name: 'Turkmenistan', value: '+993', label: 'TM(+993)' },
  { name: 'Turks and Caicos Islands', value: '+1-649', label: 'TC(+1-649)' },
  { name: 'Tuvalu', value: '+688', label: 'TV(+688)' },
  { name: 'Uganda', value: '+256', label: 'UG(+256)' },
  { name: 'Ukraine', value: '+380', label: 'UA(+380)' },
  { name: 'United Arab Emirates', value: '+971', label: 'AE(+971)' },
  { name: 'United Kingdom', value: '+44', label: 'GB(+44)' },
  { name: 'United States', value: '+1', label: 'US(+1)' },
  {
    name: 'United States Minor Outlying Islands',
    value: '+1',
    label: 'UM(+1)',
  },
  { name: 'Uruguay', value: '+598', label: 'UY(+598)' },
  { name: 'Uzbekistan', value: '+998', label: 'UZ(+998)' },
  { name: 'Vanuatu', value: '+678', label: 'VU(+678)' },
  { name: 'Venezuela, Bolivarian Republic of', value: '+58', label: 'VE(+58)' },
  { name: 'Viet Nam', value: '+84', label: 'VN(+84)' },
  { name: 'Virgin Islands, British', value: '+1-284', label: 'VG(+1-284)' },
  { name: 'Virgin Islands, U.S.', value: '+1-340', label: 'VI(+1-340)' },
  { name: 'Wallis and Futuna', value: '+681', label: 'WF(+681)' },
  { name: 'Western Sahara', value: '+212', label: 'EH(+212)' },
  { name: 'Yemen', value: '+967', label: 'YE(+967)' },
  { name: 'Zambia', value: '+260', label: 'ZM(+260)' },
  { name: 'Zimbabwe', value: '+263', label: 'ZW(+263)' },
];

export type CountryOption = { label: string; value: string };

/**
 * Dial-code options that can actually be told apart. `label` names the country
 * ("IN(+91) India") so react-select's default filter matches what people type,
 * and so the ten codes shared by several countries (+1, +61, +47) stop
 * rendering as identical rows.
 */
export const countryOptions: CountryOption[] = countries.map((data) => ({
  label: `${data.label} ${data.name}`,
  value: data.value,
}));

/**
 * Pair with `countryOptions`. The menu gets the full label; the closed control
 * gets the bare dial code, because it sits in a ~100px-wide input adornment
 * that the full label would overflow.
 */
export const formatCountryOption = (
  option: CountryOption,
  meta: { context: 'menu' | 'value' },
) => (meta.context === 'menu' ? option.label : option.value);

export default countries;
